import { DataStore } from 'common/module/data/store';
import { PaginationComponentPropsInterface } from 'common/module/pagination/component-props.interface';
import { PaginationViewStoreEvent } from 'common/module/pagination/view-store.event';
import { PaginationViewStoreOptionsInterface } from 'common/module/pagination/view-store-options.interface';

export class PaginationViewStore extends DataStore {
  /**
   * Number of pages to display in the list of pages
   */
  private static readonly PAGE_DISPLAY_COUNT: number = 10;

  /**
   * @inheritDoc
   */
  protected state: PaginationComponentPropsInterface;

  /**
   * @inheritDoc
   */
  public initialize(options: PaginationViewStoreOptionsInterface): void {
    this.state = {
      currentPage: options.currentPage || 1,
      limit: options.limit,
      total: options.total || 0,
      pageCount: options.pageCount,
      href: '',
      nextLinkTitle: options.nextLinkTitle,
      prevLinkTitle: options.prevLinkTitle,
      amountOfPagesShown: options.amountOfPagesShown || PaginationViewStore.PAGE_DISPLAY_COUNT,
      onClickPage: this.onClickPage,
    };
  }

  /**
   * @inheritDoc
   */
  public getState(): PaginationComponentPropsInterface {
    return this.state;
  }

  /**
   * Update page state
   */
  public updatePage(currentPage: number): void {
    this.setState(
      {
        ...this.state,
        currentPage,
      },
      this.updatePage
    );
  }

  /**
   * Update pagination state
   */
  public updatePagination(currentPage: number, totalRecords: number): void {
    this.setState(
      {
        ...this.state,
        currentPage,
        total: totalRecords,
      },
      this.updatePagination
    );
  }

  /**
   * Toggle enable/disable pagination
   */
  public toggleDisabled(isDisabled: boolean): void {
    this.setState({
      ...this.state,
      disabled: isDisabled,
    });
  }

  /**
   * Set pagination limit
   */
  public setLimit(limit: number): void {
    this.setState({
      ...this.state,
      limit,
    });
  }

  /**
   * Click page in pagination
   */
  private onClickPage = (e: Event, page: number): void => {
    e.preventDefault();

    this.updatePage(page);

    this.getEventEmitter().emit(PaginationViewStoreEvent.clickPage, {
      page,
      limit: this.state.limit,
      total: this.state.total,
    });
  };
}
